export default "/static/media/optus.75d1e076.svg";